"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Header = _interopRequireDefault(require("../../components/Header"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _NoProjectsMessage = _interopRequireDefault(require("../../components/NoProjectsMessage"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _useEnsureDeploymentIds = _interopRequireDefault(require("../../hooks/useEnsureDeploymentIds"));
var _admin = require("../../selectors/admin.js");
var _admin2 = require("../../reducers/admin.js");
var _metricsDataTable = _interopRequireDefault(require("./metricsDataTable.js"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _CustomQueryForm = _interopRequireDefault(require("./CustomQueryForm"));
var _cog = _interopRequireDefault(require("cccisd-icons/cog"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _deepEqual = _interopRequireDefault(require("deep-equal"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _style = _interopRequireDefault(require("./style.css"));
var _NewVisualize = _interopRequireDefault(require("./NewVisualize"));
var _QueryNameForm = _interopRequireDefault(require("./QueryNameForm"));
var _showLoader = _interopRequireDefault(require("./showLoader.js"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Fortress = window.cccisd.fortress;
var Boilerplate = window.cccisd.boilerplate;
var Data = function Data(props) {
  var project = props.project,
    assignmentId = props.assignmentId,
    assignmentIdWhitelist = props.assignmentIdWhitelist,
    customSwitchProject = props.customSwitchProject,
    deploymentIdWhitelist = props.deploymentIdWhitelist,
    deploymentIds = props.deploymentIds,
    hideProjectDropdown = props.hideProjectDropdown,
    isExported = props.isExported,
    labelForDeployment = props.labelForDeployment,
    labelForProject = props.labelForProject,
    labelForProjectPlural = props.labelForProjectPlural,
    labelForQuest = props.labelForQuest,
    labelForSurvey = props.labelForSurvey,
    projectIdWhitelist = props.projectIdWhitelist,
    projectQueries = props.projectQueries,
    currentQueryId = props.currentQueryId,
    currentQuerySettings = props.currentQuerySettings,
    showCustomizeButton = props.showCustomizeButton,
    showVisualizeButton = props.showVisualizeButton,
    showSaveButton = props.showSaveButton,
    showQueriesWithTags = props.showQueriesWithTags,
    constantFilter = props.constantFilter,
    overrideInitialVisualizeSettings = props.overrideInitialVisualizeSettings,
    overrideVisualizeDeploymentLabels = props.overrideVisualizeDeploymentLabels;
  var deployments = props.deployments.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      visualizeLabel: overrideVisualizeDeploymentLabels && overrideVisualizeDeploymentLabels[item.deploymentId] || item.label || ''
    });
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var tooltipRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    assignmentMetrics = _useState2[0],
    setAssignmentMetrics = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    metricsToVisualize = _useState4[0],
    setMetricsToVisualize = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    tableFilters = _useState6[0],
    setTableFilters = _useState6[1];
  var assignmentSurveys = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentQueryAssignmentSurveys)(state.assignment.admin);
  });
  var restrictionsLevel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getRestrictionsLevel)(state.assignment.admin);
  });
  var canViewData = Fortress.hasAnyAccess(_questPermissionsByArea["default"].data.permissions, project && project.groupId || 0);
  (0, _useEnsureDeploymentIds["default"])();
  var filteredProjectQueries = (0, _react.useMemo)(function () {
    if (!showQueriesWithTags) {
      return projectQueries;
    }
    return projectQueries.filter(function (query) {
      var _query$settings;
      var queryTags = (_query$settings = query.settings) === null || _query$settings === void 0 ? void 0 : _query$settings.tags;
      return queryTags && (0, _intersection2["default"])(queryTags, showQueriesWithTags).length > 0;
    });
  }, [showQueriesWithTags, projectQueries]);
  (0, _react.useEffect)(function () {
    var foundQuery = filteredProjectQueries.find(function (query) {
      return query.id === currentQueryId;
    });
    if (!foundQuery && showQueriesWithTags && filteredProjectQueries.length > 0) {
      dispatch((0, _admin2.setCurrentQueryId)(filteredProjectQueries[0].id));
    }
  }, [currentQueryId, filteredProjectQueries, showQueriesWithTags]);
  var loadAssignmentMetrics = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!assignmentMetrics[id]) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              (0, _showLoader["default"])( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var response, metrics;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _cccisdAxios["default"].get(Boilerplate.route('api.assignment.metrics.customVariableList', {
                          assignmentId: id
                        }));
                      case 2:
                        response = _context.sent;
                        // we need deduplicate list as we could have the same reportHeader for different languages
                        metrics = (0, _uniqBy2["default"])(response.data.data.metrics.variableList, 'reportHeader').map(function (item) {
                          var _item$key;
                          return {
                            reportHeader: item.reportHeader,
                            surveyHandles: item.surveyHandles,
                            type: item.type,
                            label: item.label,
                            question: item.key.title,
                            questionType: item.key.questionType,
                            isIdentifying: Boolean(item === null || item === void 0 ? void 0 : (_item$key = item.key) === null || _item$key === void 0 ? void 0 : _item$key.isIdentifying),
                            isFile: item.tagList.some(function (obj) {
                              return obj.scope === 'system' && obj.handle === 'fileUpload';
                            })
                          };
                        });
                        setAssignmentMetrics(function (prev) {
                          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, metrics));
                        });
                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function loadAssignmentMetrics(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    loadAssignmentMetrics(currentQuerySettings.assignmentId);
  }, [currentQuerySettings.assignmentId]);
  var hasChanges = (0, _react.useMemo)(function () {
    if (!currentQueryId || currentQueryId === '0') {
      return false;
    }
    var foundQuery = filteredProjectQueries.find(function (query) {
      return query.id === currentQueryId;
    });
    return foundQuery ? !(0, _deepEqual["default"])(
    // vizualize will handle its own equality check
    (0, _omit2["default"])(foundQuery.settings, ['visualizationSettings']), (0, _omit2["default"])(currentQuerySettings, ['visualizationSettings'])) : true;
  }, [currentQuerySettings, currentQueryId, filteredProjectQueries]);
  var syncTableFilters = function syncTableFilters(filters) {
    var filterValues = Object.values(filters).filter(function (f) {
      return f.props.value;
    }).map(function (f) {
      return {
        contains: {
          field: f.props.column,
          string: f.props.value
        }
      };
    });
    if (constantFilter) {
      filterValues.push(constantFilter);
    }
    if (!tableFilters || !(0, _isEqual2["default"])(filterValues, tableFilters)) {
      setTableFilters(filterValues);
    }
  };
  if (!canViewData) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], {
      customSwitchProject: customSwitchProject,
      hideProjectDropdown: hideProjectDropdown,
      isExported: isExported,
      labelForProject: labelForProject,
      labelForProjectPlural: labelForProjectPlural,
      limitProjectsByPermissions: _questPermissionsByArea["default"].data.permissions,
      projectIdWhitelist: projectIdWhitelist
    });
  }
  var currentAssignmentMetrics = assignmentMetrics[currentQuerySettings.assignmentId];
  var getRightSection = function getRightSection() {
    var showQueryDropdown = function () {
      if (showSaveButton) {
        return true;
      }
      if (filteredProjectQueries.length < 2) {
        return false;
      }
      return true;
    }();
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].customize
    }, showQueryDropdown && /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group",
      style: {
        marginBottom: 0
      }
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "control-label"
    }, "Query"), /*#__PURE__*/_react["default"].createElement("select", {
      className: "form-control",
      name: "query",
      style: {
        maxWidth: '200px'
      },
      onChange: function onChange(e) {
        return dispatch((0, _admin2.setCurrentQueryId)(e.target.value));
      },
      value: currentQueryId
    }, !showQueriesWithTags && /*#__PURE__*/_react["default"].createElement("option", {
      value: "0"
    }, "Default"), filteredProjectQueries.map(function (query) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        value: query.id,
        key: query.id
      }, query.name);
    }))), showCustomizeButton && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default",
        style: {
          marginLeft: '1rem'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cog["default"], {
        spaceRight: true
      }), "Customize"),
      title: "Customize query",
      size: "large",
      render: function render(_ref3) {
        var closeModal = _ref3.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_CustomQueryForm["default"], {
          assignmentMetrics: assignmentMetrics,
          loadAssignmentMetrics: loadAssignmentMetrics,
          initialValues: currentQuerySettings,
          onSubmit: function onSubmit(values) {
            return dispatch((0, _admin2.setCurrentQuerySettings)(values));
          },
          onDelete: showSaveButton && currentQueryId && currentQueryId !== '0' ? function () {
            closeModal();
            dispatch((0, _admin2.deleteCurrentQuery)());
          } : null,
          closeModal: closeModal
        });
      }
    }), restrictionsLevel !== 'basic' && showVisualizeButton && /*#__PURE__*/_react["default"].createElement(_NewVisualize["default"], {
      metrics: metricsToVisualize,
      deploymentIds: deploymentIds,
      deployments: deployments,
      tableFilters: tableFilters,
      currentQueryId: currentQueryId,
      currentQuerySettings: currentQuerySettings,
      SaveQueryButton: SaveQueryButton,
      overrideInitialVisualizeSettings: overrideInitialVisualizeSettings,
      renderSaveQueryButton: function renderSaveQueryButton(buttonProps) {
        return /*#__PURE__*/_react["default"].createElement(SaveQueryButton, _extends({
          showSaveButton: showSaveButton,
          project: project,
          currentQueryId: currentQueryId,
          tooltipRef: tooltipRef,
          dispatch: dispatch,
          currentQuerySettings: currentQuerySettings,
          hasChanges: hasChanges
        }, buttonProps));
      }
    }), /*#__PURE__*/_react["default"].createElement(SaveQueryButton, {
      showSaveButton: showSaveButton,
      project: project,
      currentQueryId: currentQueryId,
      tooltipRef: tooltipRef,
      dispatch: dispatch,
      currentQuerySettings: currentQuerySettings,
      hasChanges: hasChanges
    }));
  };
  var showHeader = !hideProjectDropdown || showCustomizeButton || showSaveButton || showVisualizeButton || filteredProjectQueries.length > 1;
  if (filteredProjectQueries.length === 0 && showQueriesWithTags) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: _style["default"].info
    }, "There are no queries to show");
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showHeader && /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    assignmentIdWhitelist: assignmentIdWhitelist,
    customSwitchProject: customSwitchProject,
    deploymentIdWhitelist: deploymentIdWhitelist,
    isExported: isExported,
    labelForDeployment: labelForDeployment,
    labelForProject: labelForProject,
    labelForProjectPlural: labelForProjectPlural,
    labelForQuest: labelForQuest,
    labelForSurvey: labelForSurvey,
    projectIdWhitelist: projectIdWhitelist,
    limitProjectsByPermissions: _questPermissionsByArea["default"].data.permissions,
    showProjectDropdown: !hideProjectDropdown,
    showQuestCount: false,
    rightSection: getRightSection()
  }), !assignmentId && /*#__PURE__*/_react["default"].createElement(_NoProjectsMessage["default"], {
    isExported: isExported
  }), assignmentId && deploymentIds.length > 0 && currentAssignmentMetrics && /*#__PURE__*/_react["default"].createElement(_metricsDataTable["default"], {
    metrics: currentAssignmentMetrics,
    deploymentIds: deploymentIds,
    syncTableFilters: syncTableFilters,
    constantFilter: constantFilter,
    setMetricsToVisualize: setMetricsToVisualize,
    showCustomizeButton: showCustomizeButton
  }) || null, assignmentId && assignmentSurveys.length === 0 && /*#__PURE__*/_react["default"].createElement("h3", {
    className: _style["default"].info
  }, "This ", labelForQuest || 'Quest', " does not have any ", labelForSurvey || 'survey', "s"), assignmentId && assignmentSurveys.length !== 0 && deploymentIds.length === 0 && /*#__PURE__*/_react["default"].createElement("h3", {
    className: _style["default"].info
  }, "No data for selected ", labelForDeployment || 'Data Collection Wave', "s") || /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null));
};
Data.propTypes = {
  assignmentId: _propTypes["default"].number,
  assignmentIdWhitelist: _propTypes["default"].array,
  customSwitchProject: _propTypes["default"].func,
  deploymentIdWhitelist: _propTypes["default"].array,
  deploymentIds: _propTypes["default"].array,
  deployments: _propTypes["default"].array,
  hideDeploymentDropdown: _propTypes["default"].bool,
  hideProjectDropdown: _propTypes["default"].bool,
  hideQuestDropdown: _propTypes["default"].bool,
  hideSystemId: _propTypes["default"].bool,
  isExported: _propTypes["default"].bool,
  labelForDeployment: _propTypes["default"].string,
  labelForProject: _propTypes["default"].string,
  labelForProjectPlural: _propTypes["default"].string,
  labelForQuest: _propTypes["default"].string,
  labelForSurvey: _propTypes["default"].string,
  project: _propTypes["default"].object,
  projectAssignments: _propTypes["default"].array,
  projectIdWhitelist: _propTypes["default"].array,
  projectQueries: _propTypes["default"].array,
  currentQueryId: _propTypes["default"].string,
  currentQuerySettings: _propTypes["default"].object,
  showCustomizeButton: _propTypes["default"].bool,
  showVisualizeButton: _propTypes["default"].bool,
  showSaveButton: _propTypes["default"].bool,
  showQueriesWithTags: _propTypes["default"].array,
  constantFilter: _propTypes["default"].object,
  overrideInitialVisualizeSettings: _propTypes["default"].object,
  overrideVisualizeDeploymentLabels: _propTypes["default"].object
};
Data.defaultProps = {
  showCustomizeButton: true,
  showVisualizeButton: true,
  showSaveButton: true
};
var mapStateToProps = function mapStateToProps(state) {
  var _getPopulatedCurrentQ = (0, _admin.getPopulatedCurrentQuerySettings)(state.assignment.admin),
    deployments = _getPopulatedCurrentQ.deployments,
    deploymentIds = _getPopulatedCurrentQ.deploymentIds;
  return {
    project: (0, _admin.getCurrentProject)(state.assignment.admin),
    assignmentId: state.assignment.admin.currentQuerySettings.assignmentId,
    deployments: deployments,
    deploymentIds: deploymentIds,
    projectQueries: (0, _admin.getCurrentProjectQueries)(state.assignment.admin),
    currentQueryId: state.assignment.admin.currentQueryId,
    currentQuerySettings: state.assignment.admin.currentQuerySettings
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(Data); // **********************
exports["default"] = _default;
function SaveQueryButton(_ref4) {
  var showSaveButton = _ref4.showSaveButton,
    project = _ref4.project,
    currentQueryId = _ref4.currentQueryId,
    tooltipRef = _ref4.tooltipRef,
    dispatch = _ref4.dispatch,
    currentQuerySettings = _ref4.currentQuerySettings,
    hasChanges = _ref4.hasChanges;
  if (!showSaveButton || !Fortress.hasAccess('quest.tables_edit', project === null || project === void 0 ? void 0 : project.groupId)) {
    return null;
  }
  if (currentQueryId && currentQueryId !== '0') {
    return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '0.5rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-default",
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          dispatch((0, _admin2.updateQuery)({
            id: currentQueryId,
            settings: currentQuerySettings
          }));
          tooltipRef.current && tooltipRef.current.hide();
        }
      }, "Update query")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref5) {
          var _onClick = _ref5.onClick;
          return /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-default",
            onClick: function onClick() {
              _onClick();
              tooltipRef.current && tooltipRef.current.hide();
            }
          }, "Save as New query");
        },
        title: "Choose query name"
      }, /*#__PURE__*/_react["default"].createElement(_QueryNameForm["default"], {
        onSubmit: function onSubmit(values) {
          dispatch((0, _admin2.addNewQuery)({
            name: values.name,
            settings: currentQuerySettings
          }));
        }
      })))),
      tippyProps: {
        trigger: 'click',
        placement: 'bottom-end',
        arrow: false,
        interactive: true,
        theme: 'light',
        offset: [0, 5],
        onShow: function onShow(instance) {
          tooltipRef.current = instance;
        }
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: hasChanges ? 'btn btn-warning' : 'btn btn-default',
      style: {
        marginLeft: '1rem'
      }
    }, "Save"));
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: hasChanges ? 'btn btn-warning' : 'btn btn-default',
      style: {
        marginLeft: '1rem'
      }
    }, "Save"),
    title: "Choose query name"
  }, /*#__PURE__*/_react["default"].createElement(_QueryNameForm["default"], {
    onSubmit: function onSubmit(values) {
      dispatch((0, _admin2.addNewQuery)({
        name: values.name,
        settings: currentQuerySettings
      }));
    }
  }));
}